import { addToast } from "@heroui/react";
import { t } from "@lingui/core/macro";

const TOAST_TIMEOUT_MS = 12000;

// Same stretched-target pattern as supportChatBlockedToast: on mobile the
// sidebar chat button is hidden behind the menu, so the toast is the way back.
export function showSupportReplyToast(onOpen: () => void) {
  addToast({
    color: "success",
    timeout: TOAST_TIMEOUT_MS,
    title: t`Nov odgovor podpore`,
    description: (
      <>
        {t`Dotaknite se tega sporočila, da odprete klepet.`}
        <button
          type="button"
          aria-label={t`Odpri klepet s svetovalcem`}
          className="absolute inset-0 cursor-pointer"
          onClick={onOpen}
        />
      </>
    ),
  });
}
